import getPictureUrl from "@/helpers/getPictureUrl";
import { IMAGE_SRC_TYPES } from "@/config/image";

export class Picture {

  constructor(data, image) {
    this.id = data.id
    this.srcNumber = data.src_number
    this.srcType = data.src_type || IMAGE_SRC_TYPES.IMAGE
    this.src = data.src

    this.imageId = image?.id || null

    this.srcXs = getPictureUrl(this.src, this.srcNumber, this.srcType, 'xs')
    this.srcSm = getPictureUrl(this.src, this.srcNumber, this.srcType, 'sm')
    this.srcMd = getPictureUrl(this.src, this.srcNumber, this.srcType, 'md')
    this.srcLg = getPictureUrl(this.src, this.srcNumber, this.srcType, 'lg')
    this.srcXl = getPictureUrl(this.src, this.srcNumber, this.srcType, 'xl')
  }

  get isYoutube() {
    return this.srcType === IMAGE_SRC_TYPES.YOUTUBE
  }

}

export default Picture
